import classNames from 'classnames'
import type { Variation } from 'src/components/product-page/Selector/types'
import './tiled-selector.scss'

type TiledSelectorProps = {
  variation: Variation
  sortedVariationValues: Array<{
    id: string
    name: string
    isAvailable: boolean
    selected: boolean
  }>
  variationName: string
  onClickVariation: (name: string, value: string) => void
  sendAmplitudeEvent: (value: string) => void
}

const TiledSelector = ({
  variation,
  sortedVariationValues,
  variationName,
  onClickVariation,
  sendAmplitudeEvent,
}: TiledSelectorProps) => {
  return (
    <div>
      <ul
        className="flex items-center flex-wrap gap-1 mt-5"
        key={variation.field.id}
        data-testid="default-selector"
      >
        {sortedVariationValues.map((variationValue, index) => (
          <li key={variationValue.id}>
            <button
              disabled={!variationValue.isAvailable}
              className={classNames('size-selector-btn', {
                selected: variationValue.selected,
                disabled: !variationValue.isAvailable,
              })}
              onClick={() => {
                onClickVariation(variationName, variationValue.name)

                sendAmplitudeEvent(variationValue.name)
              }}
              data-testid={`variant-size-${index}`}
            >
              {variationValue.name}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default TiledSelector
